import Image            from "gatsby-image";
import React            from "react";
import Opengraph        from "../../../../assets/images/cases/fundacja/og.png"
import {FundacjaImages} from "./FundacjaImage";

export const FundacjaData = () => {
  const images = FundacjaImages();
  return {
    color:          "#fff",
    title:          "Fundacja Świat Bez Barier",
    seo:
                    "Prowadzimy zabiegi z zakresu osteopatii i fizjoterapii pediatrycznej. Naszą ofertę kierujemy zarówno do młodszych i starszych dzieci, jak i dorosłych.",
    slug:           "fundacja",
    opengraph:      Opengraph,
    hero:           {
      title:      "Czas rozwinąć skrzydła.",
      color:      "",
      background: (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"cover"}
                      fluid={images.hero.childImageSharp.fluid}
                    />
                  ),
      detail:     (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"contain"}
                      fluid={images.detail.childImageSharp.fluid}
                    />
                  ),
    },
    list:           {
      background: (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"contain"}
                      fluid={images.list_bg.childImageSharp.fluid}
                    />
                  ),
      detail:     (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"contain"}
                      fluid={images.list_detail.childImageSharp.fluid}
                    />
                  ),
    },
    what_we_did:    {
      title:        "Zobacz, jak wygląda świat bez barier!  ",
      technologies: ["Branding", "Strona internetowa", "Media społecznościowe", "Materiały wizualne"],
      text:
                    "To, że dobro wraca, wiemy nie od dziś. Dlatego gdy tylko pojawiła się możliwość współpracy z Fundacją Świat Bez Barier, nie wahaliśmy się ani chwili! Podjęliśmy się tego zadania i naszą pracę zaczęliśmy od opracowania brandingu dla nowo powstałej fundacji. Następnie zaprojektowaliśmy stronę internetową oraz kompleksowo zajęliśmy się mediami społecznościowymi. Opracowaliśmy także elementy wizualne, takie jak dyplomy czy wizytówki. Podczas prac przyświecał nam jeden cel - by podopieczni fundacji rozwinęli skrzydła!  \n",
      list:         [
        "Opracowaliśmy identyfikację wizualną Fundacji ",
        "Zaprojektowaliśmy nowoczesną stronę internetową",
        "Stworzyliśmy profile w mediach społecznościowych ",
        "Opracowaliśmy reklamowe materiały wizualne",
      ],
    },
    content_images: {
      first:    (
                  <Image
                    alt=""
                    objectPosition={"center"}
                    objectFit={"contain"}
                    fluid={images.fundacja_1.childImageSharp.fluid}
                  />
                ),
      second:   (
                  <Image
                    alt=""
                    objectPosition={"center"}
                    objectFit={"contain"}
                    fluid={images.fundacja_2.childImageSharp.fluid}
                  />
                ),
      third:    (
                  <Image
                    alt=""
                    objectPosition={"center"}
                    objectFit={"contain"}
                    fluid={images.fundacja_3.childImageSharp.fluid}
                  />
                ),
      fourth:   (
                  <Image
                    alt=""
                    objectPosition={"center"}
                    objectFit={"contain"}
                    fluid={images.fundacja_4.childImageSharp.fluid}
                  />
                ),
      fifth:    (
                  <Image
                    alt=""
                    objectPosition={"center"}
                    objectFit={"contain"}
                    fluid={images.fundacja_5.childImageSharp.fluid}
                  />
                ),
      sixth:    (
                  <Image
                    alt=""
                    objectPosition={"center"}
                    objectFit={"contain"}
                    fluid={images.fundacja_6.childImageSharp.fluid}
                  />
                ),
      seventh:  (
                  <Image
                    alt=""
                    objectPosition={"center"}
                    objectFit={"contain"}
                    fluid={images.fundacja_7.childImageSharp.fluid}
                  />
                ),
      eighth:   (
                  <Image
                    alt=""
                    objectPosition={"center"}
                    objectFit={"contain"}
                    fluid={images.fundacja_8.childImageSharp.fluid}
                  />
                ),
      ninth:    (
                  <Image
                    alt=""
                    objectPosition={"center"}
                    objectFit={"contain"}
                    fluid={images.fundacja_9.childImageSharp.fluid}
                  />
                ),
      tenth:    (
                  <Image
                    alt=""
                    objectPosition={"center"}
                    objectFit={"contain"}
                    fluid={images.fundacja_10.childImageSharp.fluid}
                  />
                ),
    },
    full_images:    {
      first:  {
        title: "",
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.fundacja_1f.childImageSharp.fluid}
                 />
               ),
      },
      second: {
        title: "",
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.fundacja_2f.childImageSharp.fluid}
                 />
               ),
      },
      third:  {
        title: "",
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.fundacja_3f.childImageSharp.fluid}
                 />
               ),
      },
      fourth: {
        title: "",
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.fundacja_4f.childImageSharp.fluid}
                 />
               ),
      },
      fifth:  {
        title: "",
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.fundacja_5f.childImageSharp.fluid}
                 />
               ),
      },
    },
    headers:        {
      first:  <>Poznaj Fundację <br/> Świat Bez Barier</>,
      second: "Wszystko dla podopiecznych Fundacji",
      third:  "Pomaganie jest fajne!",
      fourth: "Rozwijanie pasji i spełnianie marzeń",
    },

    text_boxes:   {
      first:    {
        title: "Pozytywny wizerunek to podstawa",
        text:
               "Zależało nam, aby Fundacja Świat Bez Barier przywoływała na myśl same miłe i pozytywne skojarzenia oraz zachęcała do wsparcia. Dlatego w brandingu użyliśmy kolorów takich jak fiolet, róż i żółty, a całość dopełniają autorskie grafiki. Użyty w logo motyw drzwi nawiązuje do nowego otwarcia w życiu wielu podopiecznych fundacji.",
      },
      second:   {
        title: "Funkcjonalne rozwiązania internetowe",
        text:
               "Kolejnym etapem prac było zaprojektowanie strony internetowej. Stworzyliśmy lekką i wydajną witrynę, która w pełni odpowiada na potrzeby Fundacji Świat Bez Barier. Strona WWW jest w pełni zintegrowana z systemem PayU, co umożliwia szybkie i intuicyjne wpłacanie darowizn. Również projekt graficzny dostosowany jest do działalności fundacji.",
      },
      third:    {
        title: "Nowoczesne technologie w programowaniu",
        text:
               "Zaprojektowana i wdrożona przez nas strona jest szybka i intuicyjna. Zastosowaliśmy nowoczesny sposób wczytywania obrazków oraz frameworków React i Gatsby, pozwalające na budowanie wydajnych stron i aplikacji internetowych. Witryna jest również zoptymalizowana pod kątem SEO.",
      },
      fourth:   {
        title: "Marketing oparty na czynieniu dobra",
        text:
               "Komunikację Fundacji Świat Bez Barier w internecie dopełniają media społecznościowe. Stworzyliśmy profile na Facebooku i Instagramie, a następnie zaprojektowaliśmy szablony graficzne, które wykorzystaliśmy przy dodawaniu postów. Wszystko tworzy spójną komunikację, której celem jest jedno - pomoc tym, którzy jej potrzebują!",
      },
      fifth: {
        title: "Cel: uśmiech każdego dziecka",
        text:
               "Fundacja Świat Bez Barier została przyjęta bardzo pozytywnie - od początku swojej działalności zorganizowała kilka akcji charytatywnych. Dzięki nowej stronie WWW udało się pozyskać wielu darczyńców. W ramach podziękowania za okazaną pomoc zaprojektowaliśmy i wykonaliśmy dyplomy dla partnerów, którzy wsparli poszczególne akcje. Niedługo później powstały ulotki informacyjne oraz skarbonki.",
      }, sixth: {
        title: "Razem zrobiliśmy coś dobrego!",
        text:
               "Opracowaliśmy także szablony graficzne, których Fundacja Świat Bez Barier używa w wysyłanych mailach. Ponadto stworzyliśmy projekt wizytówek. Wszystkie elementy wpływają na postrzeganie fundacji jako zaufanej instytucji, która swoim podopiecznym chce pomóc w starcie w dorosłość i zapewnić im jak najlepszą przyszłość. ",
      },

    },
  };
};
